import getAttributionCategory from "./getAttributionCategory";
import getPageName from "./getPageName";
import getPageType from "./getPageType";

const itemsTypeSimilarItems = state => ({
  ...state,
  globals: {
    ...state.globals,
    attributionCategory: getAttributionCategory(),
    pageName: getPageName(),
    pageType: getPageType()
  }
});

export default itemsTypeSimilarItems;
